import { render } from "./LabeledInput.vue?vue&type=template&id=54dca863&scoped=true&ts=true"
import script from "./LabeledInput.vue?vue&type=script&lang=ts"
export * from "./LabeledInput.vue?vue&type=script&lang=ts"

import "./LabeledInput.vue?vue&type=style&index=0&id=54dca863&scoped=true&lang=scss"
import "./LabeledInput.vue?vue&type=style&index=1&id=54dca863&lang=css"

import exportComponent from "../../../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dca863"]])

export default __exports__